import clsx from 'clsx';

import type * as api from '@gitbook/api-client';
import { Link } from '@gitbook/spine-react';

/**
 * Clickable subject for a conversation.
 */
export function ConversationSubject(props: { conversation: api.Conversation; className?: string }) {
    const { conversation, className } = props;

    const text = conversation.subject ?? 'No subject';

    return (
        <span className={clsx(className, conversation.subject ? 'italic' : null)}>
            {conversation.urls.source ? (
                <Link href={conversation.urls.source} kind="inherit" target="_blank">
                    {text}
                </Link>
            ) : (
                text
            )}
        </span>
    );
}
